// A single place that knows whether leaving the screen right now would throw
// away something the user typed.
//
// The event form is the one screen where a stray tap costs real work: dictate a
// long appointment, brush the "Search" tab at the bottom, and every word of it
// is gone with no warning and no way back. React Router's own navigation
// blocker is only available with the data router, which this app does not use,
// so the form registers itself here and the bottom bar asks before moving.
//
// Deliberately tiny and deliberately global: exactly one screen at a time can
// hold unsaved work, so a module-level slot is enough and avoids threading a
// context through the whole tree.

let guard = null; // { isDirty: () => boolean, ask: (proceed) => void }

/** Called by a screen that has something to lose. Returns an unregister fn. */
export function registerUnsavedGuard(g) {
  guard = g;
  return () => { if (guard === g) guard = null; };
}

/**
 * Ask permission to navigate away.
 * Returns true when it is safe to go now. Returns false when the screen has
 * taken over: it shows its own confirmation and calls `proceed()` if the user
 * decides to discard.
 */
export function requestLeave(proceed) {
  if (!guard || !guard.isDirty()) return true;
  guard.ask(proceed);
  return false;
}

/** True if something would be lost right now (no prompt, no side effects). */
export function hasUnsavedWork() {
  return Boolean(guard && guard.isDirty());
}
